import { CalendarSlot } from "../../../types";

export const hasMeetingOnHiddenDay = (
  meetings: CalendarSlot[],
  visibleWeekDays: number[],
): boolean => {
  if (visibleWeekDays.length === 0) {
    return meetings.length > 0;
  }

  const visibleSet = new Set(visibleWeekDays);

  return meetings.some((meeting) => !visibleSet.has(new Date(meeting.startTime).getDay()));
};

export const hasMeetingOutsideFocusHours = (
  meetings: CalendarSlot[],
  focusStartHour: number,
  focusEndHour: number,
): boolean => {
  if (!Number.isFinite(focusStartHour) || !Number.isFinite(focusEndHour)) {
    return false;
  }

  const rangeStartMinutes = focusStartHour * 60;
  const rangeEndMinutes = focusEndHour * 60;

  return meetings.some((meeting) => {
    const meetingStartMinutes = new Date(meeting.startTime).getHours() * 60 + new Date(meeting.startTime).getMinutes();
    const meetingEndMinutes = new Date(meeting.endTime).getHours() * 60 + new Date(meeting.endTime).getMinutes();

    return meetingEndMinutes <= rangeStartMinutes || meetingStartMinutes >= rangeEndMinutes;
  });
};
